import RoundedImg from "../RoundedImg.component";

const ProfileViewer = ({
  imageSource,
  name,
  _id,
  imageHeight,
  imageWidth,
  className,
  designation = "",
}) => {
  return (
    <div className={`flex-row align-center justify-start ${className}`}>
      <RoundedImg src={imageSource} height={imageHeight} width={imageWidth} />
      <div className="flex-col align-start justify-start g-05 profileDetails">
        <span className="poppins t-14">{name}</span>
        <span className="poppins-semiBold t-10 color-grayColor">
          {designation && designation}
        </span>
        <span className="poppins t-10 color-grayColor"> ID: {_id}</span>
      </div>
    </div>
  );
};

export default ProfileViewer;
